import { AlertDialog as AlertDialogPrimitive } from 'radix-ui';

type AlertDialogProps = React.ComponentProps<typeof AlertDialogPrimitive.Root>;

export const AlertDialog = ({ ...props }: AlertDialogProps) => (
  <AlertDialogPrimitive.Root data-slot="alert-dialog" {...props} />
);
